import React, { useEffect } from 'react'

import { GTMProvider } from '@psdlabs/gtm'

import { Provider } from 'react-redux'

import { PersistGate } from 'redux-persist/integration/react'

import { store, persistor } from '~/store'

import { setReleaseId } from '@psdhub/newrelic'
import ThemeProvider from '@psdhub/common/layout/Provider'

import ModalSupport from '~/components/ModalSupport'

import GlobalStyle from '~/styles/global'
import Routes from '~/routes'

import '~/middlewares/hadReAttempt'
import { init as initNewRelic } from './services/newrelic'

const App: React.FC = () => {
  useEffect(() => {
    setTimeout(() => {
      // instanciacao do NR sem timeout está quebrando o projeto
      initNewRelic()
    }, 6000)
  })

  return (
    <GTMProvider>
      <ThemeProvider cssVarPrefix="hub">
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <Routes />
            <ModalSupport />
          </PersistGate>
        </Provider>
        <GlobalStyle />
      </ThemeProvider>
    </GTMProvider>
  )
}

setReleaseId(process.env.REACT_APP_VERSION as string)

export default App
